import { useState, useEffect } from "react";
import {
  MdOutlineSecurity,
  MdDarkMode,
  MdDesktopAccessDisabled,
} from "react-icons/md";
import { FaStore } from "react-icons/fa";
import { AiFillBank } from "react-icons/ai";
import { FaDisplay } from "react-icons/fa6";
import {
  IoIosNotifications,
  IoMdNotificationsOff,
  IoIosArrowForward,
  IoIosArrowDown,
} from "react-icons/io";
import { CgWebsite } from "react-icons/cg";
import { IoNotifications } from "react-icons/io5";
import { RiBillLine } from "react-icons/ri";
import { TiUserDelete } from "react-icons/ti";
import "./Setting.css";
import { FiSettings } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import Plandetails from "./Plandetails";
import { toast } from "react-toastify";

function Settings({
  vendor,
  sub,
  fetchvendor,
  sendotp,
  parsedLinks,
  verifyotp,
}) {
  const [showEditForm, setShowEditForm] = useState({
    main: true,
    security: false,
    store: false,
    bank: false,
    portal: false,
    bill: false,
    acc: false,
  });
  const [isEditable, setIsEditable] = useState(false);
  const [storeInfo, setStoreInfo] = useState({
    vendor_name: vendor?.name || "",
    shop_name: vendor?.store_name || "",
    gst: vendor?.gst_no || "",
    office_address: vendor?.address || "",
    pickup_address: vendor?.pickup_add || "",
    website_url: vendor?.website_url || "",
    instagram: vendor?.instagram || "",
    facebook: vendor?.facebook || "",
    tax_doc: null,
    business_doc: null,
  });
  const [isBankEditable, setIsBankEditable] = useState(false);
  const [bankInfo, setBankInfo] = useState({
    bank_name: "",
    acc_holder_name: "",
    acc_no: "",
    ifsc: "",
  });
  const [showDocModal, setShowDocModal] = useState(false);
  const [docUrl, setDocUrl] = useState("");
  const [step, setStep] = useState(1);
  const [otp, setOtp] = useState("");
  const [timer, setTimer] = useState(0);
  const [isDarkMode, setIsDarkMode] = useState(false);
  const [isDisplaySettingsOpen, setIsDisplaySettingsOpen] = useState(true);
  const navigate = useNavigate();

  const [blocks, setBlocks] = useState([]);
  const [CategoryId, setCategoryId] = useState("");

  const vendorDetails = JSON.parse(localStorage.getItem("vendorData"));

  const addBlock = () => {
    setBlocks([...blocks, { header: "", subs: [""] }]);
  };

  const updateHeader = (i, value) => {
    const updated = [...blocks];
    updated[i].header = value;
    setBlocks(updated);
  };

  const updateSub = (blockIndex, subIndex, value) => {
    const updated = [...blocks];
    updated[blockIndex].subs[subIndex] = value;
    setBlocks(updated);
  };

  const addSub = (i) => {
    const updated = [...blocks];
    updated[i].subs.push("");
    setBlocks(updated);
  };

  const removeBlock = (i) => {
    setBlocks(blocks.filter((_, index) => index !== i));
  };

  const removeSub = (blockIndex, subIndex) => {
    const updated = [...blocks];
    updated[blockIndex].subs.splice(subIndex, 1);
    setBlocks(updated);
  };


  const handleChange = (field, value) => {
    setStoreInfo((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleFileChange = (field, file) => {
    setStoreInfo((prev) => ({
      ...prev,
      [field]: file,
    }));
  };

  const handleBankSave = async () => {
    const formData = new FormData();
    formData.append("vendor_id", vendorDetails?.id);
    formData.append("bank_name", bankInfo.bank_name || vendor.bank_name);
    formData.append(
      "acc_holder_name",
      bankInfo.acc_holder_name || vendor.acc_holder_name
    );
    formData.append("acc_no", bankInfo.acc_no || vendor.acc_no);
    formData.append("ifsc", bankInfo.ifsc || vendor.ifsc);

    try {
      const res = await fetch(
        `${process.env.REACT_APP_BASEURL}/apis/vendor/bank_in_up.php`,
        {
          method: "POST",
          body: formData,
        }
      );
      const data = await res.json();
      if (data.success || data.status === "success") {
        setIsBankEditable(false);
        fetchvendor();
        alert("Bank Details Updated Successfully");
      } else {
        alert("Action failed.");
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleStoreSave = async () => {
    const formData = new FormData();
    formData.append("vendor_id", vendorDetails?.id);
    formData.append("name", storeInfo.vendor_name || vendor.name);
    formData.append("store_name", storeInfo.store_name || vendor?.store_name);
    formData.append("gst_no", storeInfo.gst_no || vendor.gst_no);
    formData.append("pickup_add", storeInfo.pickup_add || vendor?.pickup_add);
    formData.append("ofc_add", storeInfo.address || vendor?.address);
    formData.append(
      "business_doc",
      storeInfo.business_doc || vendor.business_doc
    );
    formData.append("tax_doc", storeInfo.tax_doc || vendor.tax_doc);

    const links = [
      { key: "i", url: storeInfo.instagram },
      { key: "f", url: storeInfo.facebook },
      { key: "w", url: storeInfo.website_url },
    ];

    links.forEach((link) => {
      if (link.url) {
        formData.append("link[]", link.url);
        formData.append("link_keys[]", link.key);
      }
    });

    try {
      const res = await fetch(
        `${process.env.REACT_APP_BASEURL}/apis/vendor/store_in_up.php`,
        {
          method: "POST",
          body: formData,
        }
      );
      const data = await res.json();

      if (data.success || data.status === "success") {
        setIsEditable(false);
        fetchvendor();
        alert("Store Details Updated Successfully");
      } else {
        alert("Action failed.");
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const GetCategoryHeaders = async () => {
    try {
      const formData = new FormData();
      formData.append("id", vendorDetails?.id);
      formData.append("type", "vendor");

      const res = await fetch(
        `${process.env.REACT_APP_BASEURL}/apis/vendor/category_show.php`,
        {
          method: "POST",
          body: formData,
        }
      );

      const result = await res.json();

      if (result.status === "success") {
        const categories = result.data.flatMap(item => item.categories);
        setBlocks(categories);
        setCategoryId(result.id)
      }
    } catch (error) {
      console.error("Submit failed", error);
    }
  };

  useEffect(() => {
    GetCategoryHeaders()
  }, [])


  const handleCategorySave = async () => {
    console.log(blocks)
    try {
      const payload = {
        categories: blocks,
        vendor_id: vendorDetails?.id
      };

      const res = await fetch(`${process.env.REACT_APP_BASEURL}/apis/vendor/category_add.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const data = await res.json();
      if (data.status === "success") {
        toast.success("Header Updated Successfully")
      } else {
        console.error("Submit failed");
      }
    } catch (error) {
      console.error("Submit failed", error);
    }
  };

  const handleCategoryUpdate = async () => {
    try {
      const payload = {
        categories: blocks,
        id: CategoryId
      };

      const res = await fetch(`${process.env.REACT_APP_BASEURL}/apis/vendor/category_update.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const data = await res.json();
      if (data.status === "success") {
        toast.success("Header Updated Successfully")
      } else {
        console.error("Submit failed");
      }
    } catch (error) {
      console.error("Submit failed", error);
    }
  };

  const handlesendotp = () => {
    setStep(2);
    setTimer(180);
    sendotp("vendor", vendor?.email);
  };

  const handleDeactivate = async () => {
    const success = await verifyotp("deactivate", otp);

    setShowEditForm((pv) => ({ ...pv, acc: false }));
    setStep(1);

    if (success) {
      alert("Account Deactivated");
      navigate("/signin");
    } else {
      alert("Invalid OTP or deactivation failed.");
    }
  };

  const handleResendOtp = () => {
    alert("OTP resent to your email.");
    sendotp("vendor", vendor?.email);
    setTimer(180);
  };

  const handleThemeToggle = () => {
    setIsDarkMode((prev) => !prev);
  };

  const toggleDisplaySettings = () => {
    setIsDisplaySettingsOpen((prev) => !prev);
  };

  useEffect(() => {
    document.body.classList.toggle("dark", isDarkMode);
    document.body.classList.toggle("light", !isDarkMode);
  }, [isDarkMode]);

  useEffect(() => {
    if (timer > 0) {
      const countdown = setTimeout(() => setTimer((t) => t - 1), 1000);
      return () => clearTimeout(countdown);
    }
  }, [timer]);

  const today = new Date();

  let currentPlan = null;
  let futurePlan = null;
  let pastPlan = null;

  if (sub?.length) {
    const firstPlanDate = new Date(sub[0].month);

    if (firstPlanDate > today) {
      futurePlan = sub[0];
      currentPlan = sub[1] || null;
      pastPlan = sub.slice(2);
    } else {
      currentPlan = sub[0];
      pastPlan = sub.slice(1);
    }
  }

  const handlesendlink = (type) => {
    return async () => {
      const formData = new FormData();
      formData.append("type", type);
      formData.append("email", vendor?.email);

      try {
        const res = await fetch(
          `${process.env.REACT_APP_BASEURL}/apis/vendor/reset_link.php`,
          {
            method: "POST",
            body: formData,
          }
        );
        const data = await res.json();
        if (data.success || data.status === "success") {
          alert("Link sent to your email.");
        } else {
          alert("Failed to send link.");
        }
      } catch (error) {
        console.error("Error:", error);
      }
    };
  };

  return (
    <>
      <h1 className="dashboard-heading">
        <FiSettings /> Settings
      </h1>
      <div className="outer">
        {showEditForm?.main && (
          <div className="cardse">
            <ul className="list">
              <li
                className="element element-right"
                onClick={() => {
                  setShowEditForm((pv) => ({ ...pv, security: true }));
                  setShowEditForm((pv) => ({ ...pv, main: false }));
                }}
              >
                <MdOutlineSecurity />
                <p className="labelse">Security</p>
                <div className="control-right">
                  <IoIosArrowForward />
                </div>
              </li>
              <div className="separator1" />

              <li
                className="element element-right"
                onClick={() => {
                  setShowEditForm((pv) => ({ ...pv, store: true }));
                  setShowEditForm((pv) => ({ ...pv, main: false }));
                }}
              >
                <FaStore />
                <p className="labelse">Store Details</p>
                <div className="control-right">
                  <IoIosArrowForward />
                </div>
              </li>
              <div className="separator1" />

              <li
                className="element element-right"
                onClick={() => {
                  setShowEditForm((pv) => ({ ...pv, bank: true }));
                  setShowEditForm((pv) => ({ ...pv, main: false }));
                }}
              >
                <AiFillBank />
                <p className="labelse">Bank Details</p>
                <div className="control-right">
                  <IoIosArrowForward />
                </div>
              </li>
              <div className="separator1" />

              <li className="element" onClick={toggleDisplaySettings}>
                <FaDisplay />
                <p className="labelse">Display Settings</p>
                <div className="control-right">
                  <IoIosArrowDown />
                </div>
              </li>
              {isDisplaySettingsOpen && (
                <>
                  <li className="element element-right">
                    <MdDarkMode />
                    <p className="label">Theme</p>
                    {/* toggle btn */}
                    <div className="control-right">
                      <label className="theme-switch">
                        <input
                          type="checkbox"
                          className="theme-switch__checkbox"
                          checked={isDarkMode}
                          onChange={handleThemeToggle}
                        />
                        <div className="theme-switch__container">
                          <div className="theme-switch__clouds" />
                          <div className="theme-switch__stars-container">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 144 55"
                              fill="none"
                            >
                              <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M135.831 3.00688C135.055 3.85027 134.111 4.29946 133 4.35447C134.111 4.40947 135.055 4.85867 135.831 5.71123C136.607 6.55462 136.996 7.56303 136.996 8.72727C136.996 7.95722 137.172 7.25134 137.525 6.59129C137.886 5.93124 138.372 5.39954 138.98 5.00535C139.598 4.60199 140.268 4.39114 141 4.35447C139.88 4.2903 138.936 3.85027 138.16 3.00688C137.384 2.16348 136.996 1.16425 136.996 0C136.996 1.16425 136.607 2.16348 135.831 3.00688ZM31 23.3545C32.1114 23.2995 33.0551 22.8503 33.8313 22.0069C34.6075 21.1635 34.9956 20.1642 34.9956 19C34.9956 20.1642 35.3837 21.1635 36.1599 22.0069C36.9361 22.8503 37.8798 23.2903 39 23.3545C38.2679 23.3911 37.5976 23.602 36.9802 24.0053C36.3716 24.3995 35.8864 24.9312 35.5248 25.5913C35.172 26.2513 34.9956 26.9572 34.9956 27.7273C34.9956 26.563 34.6075 25.5546 33.8313 24.7112C33.0551 23.8587 32.1114 23.4095 31 23.3545ZM0 36.3545C1.11136 36.2995 2.05513 35.8503 2.83131 35.0069C3.6075 34.1635 3.99559 33.1642 3.99559 32C3.99559 33.1642 4.38368 34.1635 5.15987 35.0069C5.93605 35.8503 6.87982 36.2903 8 36.3545C7.26792 36.3911 6.59757 36.602 5.98015 37.0053C5.37155 37.3995 4.88644 37.9312 4.52481 38.5913C4.172 39.2513 3.99559 39.9572 3.99559 40.7273C3.99559 39.563 3.6075 38.5546 2.83131 37.7112C2.05513 36.8587 1.11136 36.4095 0 36.3545ZM56.8313 24.0069C56.0551 24.8503 55.1114 25.2995 54 25.3545C55.1114 25.4095 56.0551 25.8587 56.8313 26.7112C57.6075 27.5546 57.9956 28.563 57.9956 29.7273C57.9956 28.9572 58.172 28.2513 58.5248 27.5913C58.8864 26.9312 59.3716 26.3995 59.9802 26.0053C60.5976 25.602 61.2679 25.3911 62 25.3545C60.8798 25.2903 59.9361 24.8503 59.1599 24.0069C58.3837 23.1635 57.9956 22.1642 57.9956 21C57.9956 22.1642 57.6075 23.1635 56.8313 24.0069ZM81 25.3545C82.1114 25.2995 83.0551 24.8503 83.8313 24.0069C84.6075 23.1635 84.9956 22.1642 84.9956 21C84.9956 22.1642 85.3837 23.1635 86.1599 24.0069C86.9361 24.8503 87.8798 25.2903 89 25.3545C88.2679 25.3911 87.5976 25.602 86.9802 26.0053C86.3716 26.3995 85.8864 26.9312 85.5248 27.5913C85.172 28.2513 84.9956 28.9572 84.9956 29.7273C84.9956 28.563 84.6075 27.5546 83.8313 26.7112C83.0551 25.8587 82.1114 25.4095 81 25.3545ZM136 36.3545C137.111 36.2995 138.055 35.8503 138.831 35.0069C139.607 34.1635 139.996 33.1642 139.996 32C139.996 33.1642 140.384 34.1635 141.16 35.0069C141.936 35.8503 142.88 36.2903 144 36.3545C143.268 36.3911 142.598 36.602 141.98 37.0053C141.372 37.3995 140.886 37.9312 140.525 38.5913C140.172 39.2513 139.996 39.9572 139.996 40.7273C139.996 39.563 139.607 38.5546 138.831 37.7112C138.055 36.8587 137.111 36.4095 136 36.3545ZM101.831 49.0069C101.055 49.8503 100.111 50.2995 99 50.3545C100.111 50.4095 101.055 50.8587 101.831 51.7112C102.607 52.5546 102.996 53.563 102.996 54.7273C102.996 53.9572 103.172 53.2513 103.525 52.5913C103.886 51.9312 104.372 51.3995 104.98 51.0053C105.598 50.602 106.268 50.3911 107 50.3545C105.88 50.2903 104.936 49.8503 104.16 49.0069C103.384 48.1635 102.996 47.1642 102.996 46C102.996 47.1642 102.607 48.1635 101.831 49.0069Z"
                                fill="currentColor"
                              />
                            </svg>
                          </div>
                          <div className="theme-switch__circle-container">
                            <div className="theme-switch__sun-moon-container">
                              <div className="theme-switch__moon">
                                <div className="theme-switch__spot" />
                                <div className="theme-switch__spot" />
                                <div className="theme-switch__spot" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </label>
                    </div>
                  </li>

                  <li className="element element-right">
                    <IoIosNotifications />
                    <p className="label">Notification </p>
                    <div className="control-right">
                      <input id="checkboxInput" type="checkbox" />
                      <label className="toggleSwitch" htmlFor="checkboxInput">
                        <div className="speaker">
                          <IoNotifications />
                        </div>
                        <div className="mute-speaker">
                          <IoMdNotificationsOff />
                        </div>
                      </label>
                    </div>
                  </li>
                </>
              )}
              <div className="separator1" />

              <li className="element"
                onClick={() => {
                  setShowEditForm((pv) => ({ ...pv, portal: true }));
                  setShowEditForm((pv) => ({ ...pv, main: false }));
                }}
              >
                <CgWebsite />
                <p className="labelse">Portal Settings</p>
                <div className="control-right">
                  <IoIosArrowForward />

                </div>
              </li>

              <div className="separator1" />

              <li
                className="element element-right"
                onClick={() => {
                  setShowEditForm((pv) => ({ ...pv, bill: true }));
                  setShowEditForm((pv) => ({ ...pv, main: false }));
                }}
              >
                <RiBillLine />
                <p className="labelse">Billing & Subscription</p>
                <div className="control-right">
                  <IoIosArrowForward />
                </div>
              </li>
              <div className="separator1" />

              <li
                className="element delete1"
                onClick={() => {
                  setShowEditForm((pv) => ({ ...pv, acc: true }));
                  setOtp("");
                }}
              >
                <MdDesktopAccessDisabled />
                <p className="labelse">Account Deactivate</p>
                <div className="control-right">
                  <TiUserDelete />
                </div>
              </li>
              <div className="separator1" />
            </ul>
          </div>
        )}
        {showEditForm?.security && (
          <div className={`slide-form ${showEditForm?.security ? "open" : ""}`}>
            <div className="form-header">
              <h3>Security</h3>
              <button
                className="close1-btn"
                onClick={() => {
                  setShowEditForm((pv) => ({ ...pv, security: false }));
                  setShowEditForm((pv) => ({ ...pv, main: true }));
                }}
              >
                Back
              </button>
            </div>
            <div className="edit-profile-form">
              <div style={{ paddingBottom: "28px" }}>
                <label>Change Password:</label>
                <input type="text" value={vendor?.email} readOnly />
                <div style={{ justifyContent: "center", display: "flex" }}>
                  <button
                    type="sumbit"
                    className="changebtn"
                    onClick={(e) => {
                      handlesendlink("pass")(e);
                    }}
                  >
                    Get link
                  </button>
                </div>
              </div>
              {/* <div style={{ paddingBottom: "28px" }}>
                <label>Change E-mail:</label>
                <input type="text" placeholder="Enter your New Email" />
                <div style={{ justifyContent: "center", display: "flex" }}>
                  <button type="submit" className="changebtn">
                    Get Otp
                  </button>
                </div>
              </div> */}
              <div style={{ paddingBottom: "28px" }}>
                <label>Change Phone Number:</label>
                {/* <input type="text" value={vendor?.email} /> */}
                <input type="text" defaultValue={vendor?.email} />

                <div style={{ justifyContent: "center", display: "flex" }}>
                  <button
                    type="submit"
                    className="changebtn"
                    onClick={(e) => {
                      handlesendlink("ph")(e);
                    }}
                  >
                    Get link
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
        {showEditForm?.store && (
          <div className="slide-form open">
            <div className="form-header">
              <h3>Store Details</h3>
              <button
                className="close1-btn"
                onClick={() => {
                  setShowEditForm((pv) => ({ ...pv, store: false }));
                  setShowEditForm((pv) => ({ ...pv, main: true }));
                  setIsEditable(false);
                }}
              >
                Back
              </button>
            </div>
            <div style={{ display: "flex", justifyContent: "end" }}>
              <button
                className="edit-btn"
                onClick={() => {
                  if (!isEditable) {
                    setStoreInfo({
                      vendor_name: vendor.name || "",
                      store_name: vendor.store_name || "",
                      gst_no: vendor.gst_no || "",
                      address: vendor.address || "",
                      pickup_add: vendor.pickup_add || "",
                      website_url: parsedLinks.w || "",
                      instagram: parsedLinks.i || "",
                      facebook: parsedLinks.f || "",
                      tax_doc: vendor.tax_doc || null,
                      business_doc: vendor.business_doc || null,
                    });
                  }
                  setIsEditable(!isEditable);
                }}
              >
                {isEditable ? "Cancel" : "Edit"}
              </button>
            </div>
            <div className="flex">
              {/* LEFT SIDE */}
              <div className="edit-profile-form">
                <label>
                  Owner name:
                  {isEditable ? (
                    <input
                      type="text"
                      value={storeInfo.vendor_name}
                      onChange={(e) =>
                        handleChange("vendor_name", e.target.value)
                      }
                      placeholder="Enter your Name"
                    />
                  ) : (
                    <input type="text" value={vendor.name} readOnly />
                  )}
                </label>

                <label>
                  Shop Name:
                  {isEditable ? (
                    <input
                      type="text"
                      value={storeInfo.store_name}
                      onChange={(e) =>
                        handleChange("store_name", e.target.value)
                      }
                      placeholder="Enter your Store Name"
                    />
                  ) : (
                    <input type="text" value={vendor.store_name} readOnly />
                  )}
                </label>

                <label>
                  GST No:
                  {isEditable ? (
                    <input
                      type="text"
                      value={storeInfo.gst_no}
                      onChange={(e) => handleChange("gst_no", e.target.value)}
                      placeholder="Enter your GST No."
                    />
                  ) : (
                    <input type="text" value={vendor.gst_no} readOnly />
                  )}
                </label>

                <label>
                  Office Address:
                  {isEditable ? (
                    <input
                      type="text"
                      value={storeInfo.address}
                      onChange={(e) => handleChange("address", e.target.value)}
                      placeholder="Enter your Address"
                    />
                  ) : (
                    <input type="text" value={vendor.address} readOnly />
                  )}
                </label>

                <label>
                  Pickup Address:
                  {isEditable ? (
                    <input
                      type="text"
                      value={storeInfo.pickup_add}
                      onChange={(e) =>
                        handleChange("pickup_add", e.target.value)
                      }
                      placeholder="Enter a Pickup address"
                    />
                  ) : (
                    <input type="text" value={vendor.pickup_add} readOnly />
                  )}
                </label>
              </div>

              {/* RIGHT SIDE */}
              <div className="edit-profile-form">
                <label>
                  Website URL
                  {isEditable ? (
                    <input
                      type="url"
                      value={storeInfo.website_url}
                      onChange={(e) =>
                        handleChange("website_url", e.target.value)
                      }
                      placeholder="https://yourbrand.com"
                    />
                  ) : (
                    <input
                      type="text"
                      value={parsedLinks.w || "Not Available"}
                      readOnly
                    />
                  )}
                </label>

                <label>
                  Instagram
                  {isEditable ? (
                    <input
                      type="url"
                      value={storeInfo.instagram}
                      onChange={(e) =>
                        handleChange("instagram", e.target.value)
                      }
                      placeholder="https://instagram.com/yourbrand"
                    />
                  ) : (
                    <input
                      type="text"
                      value={parsedLinks.i || "Not Available"}
                      readOnly
                    />
                  )}
                </label>

                <label>
                  Facebook
                  {isEditable ? (
                    <input
                      type="url"
                      value={storeInfo.facebook}
                      onChange={(e) => handleChange("facebook", e.target.value)}
                      placeholder="https://facebook.com/yourbrand"
                    />
                  ) : (
                    <input
                      type="text"
                      value={parsedLinks.f || "Not Available"}
                      readOnly
                    />
                  )}
                </label>

                <label>
                  <div>Tax Certificate Document</div>
                  {isEditable ? (
                    <input
                      type="file"
                      accept="image/*"
                      onChange={(e) =>
                        handleFileChange("tax_doc", e.target.files[0])
                      }
                    />
                  ) : (
                    <>
                      {vendor.tax_doc ? (
                        <span
                          className="view-btn"
                          onClick={() => {
                            setDocUrl(
                              `${process.env.REACT_APP_BASEURL}/apis/vendor/uploads/docs/${vendor.tax_doc}`
                            );
                            setShowDocModal(true);
                          }}
                        >
                          {vendor.tax_doc}
                        </span>
                      ) : (
                        "Not Uploaded"
                      )}
                    </>
                  )}
                </label>

                <label>
                  <div>Business License Document</div>
                  {isEditable ? (
                    <input
                      type="file"
                      accept="image/*"
                      onChange={(e) =>
                        handleFileChange("business_doc", e.target.files[0])
                      }
                    />
                  ) : (
                    <>
                      {vendor.business_doc ? (
                        <span
                          className="view-btn"
                          onClick={() => {
                            setDocUrl(
                              `${process.env.REACT_APP_BASEURL}/apis/vendor/uploads/docs/${vendor.business_doc}`
                            );
                            setShowDocModal(true);
                          }}
                        >
                          {vendor.business_doc}
                        </span>
                      ) : (
                        "Not Uploaded"
                      )}
                    </>
                  )}
                </label>
              </div>
            </div>

            <div className="flex">
              {isEditable && (
                <button type="submit" onClick={handleStoreSave}>
                  Save
                </button>
              )}
            </div>
          </div>
        )}
        {showEditForm?.bank && (
          <div className="slide-form open">
            <div className="form-header">
              <h3>Bank Details</h3>
              <button
                className="close1-btn"
                onClick={() => {
                  setShowEditForm((pv) => ({ ...pv, bank: false }));
                  setShowEditForm((pv) => ({ ...pv, main: true }));
                  setIsBankEditable(false);
                }}
              >
                Back
              </button>
            </div>

            <div style={{ display: "flex", justifyContent: "end" }}>
              <button
                className="edit-btn"
                onClick={() => {
                  if (!isBankEditable) {
                    setBankInfo({
                      bank_name: vendor.bank_name || "",
                      acc_holder: vendor.acc_holder_name || "",
                      acc_number: vendor.acc_no || "",
                      ifsc: vendor.ifsc || "",
                    });
                  }
                  setIsBankEditable(!isBankEditable);
                }}
              >
                {isBankEditable ? "Cancel" : "Edit"}
              </button>
            </div>

            <div className="edit-profile-form">
              <label>
                Bank Name:
                {isBankEditable ? (
                  <input
                    type="text"
                    value={bankInfo.bank_name}
                    onChange={(e) =>
                      setBankInfo((prev) => ({
                        ...prev,
                        bank_name: e.target.value,
                      }))
                    }
                    placeholder="Enter a Bank Name"
                  />
                ) : (
                  <input type="text" value={vendor.bank_name} readOnly />
                )}
              </label>

              <label>
                Account Holder’s Name:
                {isBankEditable ? (
                  <input
                    type="text"
                    value={bankInfo.acc_holder_name}
                    onChange={(e) =>
                      setBankInfo((prev) => ({
                        ...prev,
                        acc_holder_name: e.target.value,
                      }))
                    }
                    placeholder="Enter Account Holder's Name"
                  />
                ) : (
                  <input type="text" value={vendor.acc_holder_name} readOnly />
                )}
              </label>

              <label>
                Account Number:
                {isBankEditable ? (
                  <input
                    type="text"
                    value={bankInfo.acc_no}
                    onChange={(e) =>
                      setBankInfo((prev) => ({
                        ...prev,
                        acc_no: e.target.value,
                      }))
                    }
                    placeholder="Enter Account Number"
                  />
                ) : (
                  <input type="text" value={vendor.acc_no} readOnly />
                )}
              </label>

              <label>
                IFSC:
                {isBankEditable ? (
                  <input
                    type="text"
                    value={bankInfo.ifsc}
                    onChange={(e) =>
                      setBankInfo((prev) => ({
                        ...prev,
                        ifsc: e.target.value,
                      }))
                    }
                    placeholder="Enter IFSC Code"
                  />
                ) : (
                  <input type="text" value={vendor.ifsc} readOnly />
                )}
              </label>

              {isBankEditable && (
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <button type="submit" onClick={handleBankSave}>
                    Save
                  </button>
                </div>
              )}
            </div>
          </div>
        )}
        {showEditForm?.portal && (
          <div
            style={{
              display: "flex",
              justifyContent: "space-around",
              gap: "-10px",
            }}
          >
            <div className={`slide-form ${showEditForm?.portal ? "open" : ""}`}>
              <div className="form-header">
                <button
                  className="close1-btn"
                  onClick={() => {
                    setShowEditForm((pv) => ({ ...pv, portal: false }));
                    setShowEditForm((pv) => ({ ...pv, main: true }));
                  }}
                >
                  Back
                </button>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-around",
                  gap: "50px",
                }}
              >
                <div className="edit-profile-form">
                  <h3
                    style={{
                      fontSize: "1.2rem",
                      color: "#6e68e4ff",
                      marginBottom: "20px",
                      textTransform: "uppercase",
                      textDecoration: "underline",
                      textUnderlineOffset: "4.5px",
                      textDecorationThickness: "2px",
                      textDecorationColor: "#6e68e48e",
                    }}
                  >
                    Change the slider image
                  </h3>
                  <span style={{ color: "#6c757d" }}>The feature will be added soon...</span>
                  <h3
                    style={{
                      fontSize: "1.2rem",
                      color: "#6e68e4ff",
                      marginBottom: "20px",
                      textTransform: "uppercase",
                      textDecoration: "underline",
                      textUnderlineOffset: "4.5px",
                      textDecorationThickness: "2px",
                      textDecorationColor: "#6e68e48e",
                    }}
                  >
                    Edit the Header options
                  </h3>
                  <div className="editor-container">
                    {blocks.map((block, i) => (
                      <div key={i} className="block">
                        {/* Header */}
                        <div className="input-row">
                          <label>{i + 1}</label>
                          <input
                            placeholder="Header"
                            value={block.header}
                            onChange={(e) => updateHeader(i, e.target.value)}
                          />
                          <button className="minus" onClick={() => removeBlock(i)}>
                            −
                          </button>
                        </div>

                        {/* Sub headings */}
                        {block.header &&
                          block.subs.map((sub, j) => (
                            <div key={j} className="input-row sub">
                              <input
                                placeholder="Sub heading"
                                value={sub}
                                onChange={(e) => updateSub(i, j, e.target.value)}
                              />
                              <button
                                className="minus"
                                onClick={() => removeSub(i, j)}
                              >
                                −
                              </button>
                            </div>
                          ))}

                        {/* Add sub heading */}
                        {block.header &&
                          block.subs[block.subs.length - 1] !== "" && (
                            <button className="plus sub-plus" onClick={() => addSub(i)}>
                              Add Sub Category
                            </button>
                          )}
                      </div>
                    ))}

                    {/* Add new header */}
                    <button className="plus main-plus" onClick={addBlock}>
                      Add Category
                    </button>

                    {blocks && (
                      blocks?.length === 0 ? (
                        <button onClick={handleCategorySave}>
                          Submit Categories
                        </button>
                      ) : (
                        <button onClick={handleCategoryUpdate}>
                          Update Categories
                        </button>
                      )
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {showEditForm?.bill && (
          <div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-around",
                gap: "-10px",
              }}
            >
              <div className={`slide-form ${showEditForm?.bill ? "open" : ""}`}>
                <div className="form-header">
                  <button
                    className="close1-btn"
                    onClick={() => {
                      setShowEditForm((pv) => ({ ...pv, bill: false }));
                      setShowEditForm((pv) => ({ ...pv, main: true }));
                    }}
                  >
                    Back
                  </button>
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-around",
                    gap: "50px",
                  }}
                >
                  <div className="edit-profile-form">
                    <h3
                      style={{
                        fontSize: "1.2rem",
                        color: "#6e68e4ff",
                        marginBottom: "20px",
                        textTransform: "uppercase",
                        textDecoration: "underline",
                        textUnderlineOffset: "4.5px",
                        textDecorationThickness: "2px",
                        textDecorationColor: "#6e68e48e",
                      }}
                    >
                      Current Package
                    </h3>

                    {currentPlan && (
                      <>
                        <label className="field-label">
                          <span>Name: </span>
                          <strong>{vendor?.vendor_name}</strong>
                        </label>
                        <label className="field-label">
                          <span>Email: </span>
                          <strong>{currentPlan.email}</strong>
                        </label>
                        <label className="field-label">
                          <span>Package Name: </span>
                          <strong>{currentPlan?.package}</strong>
                        </label>
                        <label className="field-label">
                          <span>Payment: </span>
                          <strong>{currentPlan?.payment}</strong>
                        </label>
                        <label className="field-label">
                          <span>Payment Method: </span>
                          <strong>{currentPlan?.payment_method}</strong>
                        </label>
                        <label className="field-label">
                          <span>Pack Validity: </span>
                          <strong>{currentPlan?.pack_validity}</strong>
                        </label>
                        <label className="field-label">
                          <span>Recharge Date:</span>{" "}
                          <strong>{currentPlan?.month}</strong>
                        </label>
                        <label className="field-label" style={{ color: "red" }}>
                          <span>Due Date: </span>
                          <strong style={{ color: "red" }}>
                            {currentPlan?.due_date}
                          </strong>
                        </label>
                      </>
                    )}
                  </div>
                  {futurePlan && (
                    <div>
                      <h3
                        style={{
                          fontSize: "1.2rem",
                          color: "#6e68e4ff",
                          marginBottom: "20px",
                          textTransform: "uppercase",
                          textDecoration: "underline",
                          textUnderlineOffset: "4.5px",
                          textDecorationThickness: "2px",
                          textDecorationColor: "#6f00ff52",
                        }}
                      >
                        Upcoming Package
                      </h3>

                      <div
                        className={`slide-form1 ${showEditForm?.bill ? "open" : ""
                          }`}
                      >
                        <div className="edit-profile-form1">
                          <div className="card-row">
                            <span>📦 Package:</span>
                            <strong>{futurePlan?.package}</strong>
                          </div>
                          <div className="card-row">
                            <span>💳 Payment:</span>
                            <strong>
                              ₹{futurePlan?.payment} via{" "}
                              {futurePlan?.payment_method.toUpperCase()}
                            </strong>
                          </div>
                          <div className="card-row">
                            <span>📅 Start Date:</span>
                            <strong>{futurePlan?.month}</strong>
                          </div>
                          <div className="card-row">
                            <span>🕑 Due Date:</span>
                            <strong>{futurePlan?.due_date}</strong>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
            {pastPlan && (
              <div style={{ maxWidth: "1000px", width: "100%" }}>
                <h2
                  style={{
                    fontSize: "1.2rem",
                    color: "#6e68e4ff",
                    marginBottom: "20px",
                    textTransform: "uppercase",
                    textDecoration: "underline",
                    textUnderlineOffset: "4.5px",
                    textDecorationThickness: "2px",
                    textDecorationColor: "#6e68e48e",
                  }}
                >
                  Subscription History
                </h2>
                <table className="subscription-table">
                  <thead>
                    <tr>
                      <th>S.No</th>
                      <th>Package</th>
                      <th>Email</th>
                      <th>Recharge Date</th>
                      <th>Validity</th>
                      <th>Transaction ID</th>
                      <th>Payment</th>
                    </tr>
                  </thead>
                  <tbody>
                    {/* Replace below with mapped data */}
                    {pastPlan?.map((sub, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{sub?.package}</td>
                        <td>{sub?.email}</td>
                        <td>{sub?.month}</td>
                        <td>{sub?.pack_validity}</td>
                        <td>{sub?.t_id}</td>
                        <td>
                          ₹{sub?.payment} via {sub?.payment_method}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
            <Plandetails />
          </div>
        )}
        {showEditForm?.acc && (
          <div className="modal-overlay-acc">
            <div className="modal-box">
              {step === 1 && (
                <>
                  <h3>Are you sure you want to deactivate your account?</h3>
                  <div className="confirm-buttons">
                    <button className="yes-btn" onClick={handlesendotp}>
                      Yes
                    </button>
                    <button
                      className="no-btn"
                      onClick={() => {
                        setShowEditForm((pv) => ({ ...pv, acc: false }));
                      }}
                    >
                      No
                    </button>
                  </div>
                </>
              )}
              {step === 2 && (
                <>
                  <button
                    className="close1-btn"
                    onClick={() => {
                      setShowEditForm((pv) => ({ ...pv, acc: false }));
                      setShowEditForm((pv) => ({ ...pv, main: true }));
                      setStep(1);
                    }}
                  >
                    Back
                  </button>
                  <h3>
                    Let’s verify it’s you - Enter the OTP sent to your inbox
                  </h3>
                  <input
                    type="text"
                    placeholder="Enter OTP"
                    value={otp}
                    onChange={(e) => setOtp(e.target.value)}
                  />

                  <div style={{ marginTop: "10px" }}>
                    <button
                      onClick={handleResendOtp}
                      // disabled={timer > 0}
                      className="resend-btn"
                    >
                      {timer > 0 ? `Resend in ${timer}s` : "Resend OTP"}
                    </button>
                  </div>

                  <button
                    // disabled={timer <= 0}
                    className="deactivate"
                    onClick={handleDeactivate}
                  >
                    Deactivate
                  </button>

                  <div className="deactivate-note">
                    <p>
                      <strong>Heads up:</strong> To reactivate your account in
                      the future, simply visit the login page and sign in using
                      your registered email. A reactivation link will be sent to
                      your inbox.
                    </p>
                    <p>
                      Just a reminder — if you lose access to your email while
                      the account is deactivated, we won’t be able to help to
                      recover it.
                    </p>
                  </div>
                </>
              )}
            </div>
          </div>
        )}
        {showDocModal && (
          <div
            className="doc-modal-overlay"
            onClick={() => setShowDocModal(false)}
          >
            <div className="doc-modal-box" onClick={(e) => e.stopPropagation()}>
              <button
                className="close-btn"
                onClick={() => setShowDocModal(false)}
              >
                ✕
              </button>
              <iframe
                src={docUrl}
                title="Document Preview"
                width="100%"
                height="500px"
                style={{ border: "none" }}
              />
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default Settings;
